export enum VolumeTypeEnum {
  CONSUMPTION_DAY = 'CONSUMPTION_DAY',
  CONSUMPTION_NIGHT = 'CONSUMPTION_NIGHT',
  CONSUMPTION_EXCLUSIVE_NIGHT = 'CONSUMPTION_EXCLUSIVE_NIGHT',
  INJECTION_DAY = 'INJECTION_DAY',
  INJECTION_NIGHT = 'INJECTION_NIGHT',
  INJECTION_EXCLUSIVE_NIGHT = 'INJECTION_EXCLUSIVE_NIGHT',
  CONSUMPTION = 'CONSUMPTION',
  INJECTION = 'INJECTION',
  CONSUMPTION_SHARED = 'CONSUMPTION_SHARED',
  CONSUMPTION_NETWORK = 'CONSUMPTION_NETWORK',
  CONSUMPTION_TH = 'CONSUMPTION_TH',
  INJECTION_TH = 'INJECTION_TH',
}
